/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateFacilityPhysician201ResponseData } from './CreateFacilityPhysician201ResponseData';
import {
    CreateFacilityPhysician201ResponseDataFromJSON,
    CreateFacilityPhysician201ResponseDataFromJSONTyped,
    CreateFacilityPhysician201ResponseDataToJSON,
} from './CreateFacilityPhysician201ResponseData';

/**
 * 
 * @export
 * @interface CreateFacilityPhysician201Response
 */
export interface CreateFacilityPhysician201Response {
    /**
     * 
     * @type {CreateFacilityPhysician201ResponseData}
     * @memberof CreateFacilityPhysician201Response
     */
    data?: CreateFacilityPhysician201ResponseData;
}

/**
 * Check if a given object implements the CreateFacilityPhysician201Response interface.
 */
export function instanceOfCreateFacilityPhysician201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateFacilityPhysician201ResponseFromJSON(json: any): CreateFacilityPhysician201Response {
    return CreateFacilityPhysician201ResponseFromJSONTyped(json, false);
}

export function CreateFacilityPhysician201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityPhysician201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CreateFacilityPhysician201ResponseDataFromJSON(json['data']),
    };
}

export function CreateFacilityPhysician201ResponseToJSON(value?: CreateFacilityPhysician201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateFacilityPhysician201ResponseDataToJSON(value.data),
    };
}

